// extracted by mini-css-extract-plugin
export default {"sortMenu":"SortMenu_sortMenu__DHtfI","title":"SortMenu_title__Xx6uw"};